module.exports = __webpack_public_path__ + "img/crutch.2011eecb.svg";